module.exports = __webpack_public_path__ + "img/unlock-square.224dd752.svg";